import json from './sprite.js';

export default {
    handle: 'SP_SPT11-Pool',
    label: 'es_SPT11-Pool_234684247',
    json,
};
